// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-modal-info {
  height: 100vh;
  position: relative;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
  background-color: var(--background-color);
}

.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
  width: 100%;
}

.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 20px;
}

.grow {
  flex-grow: 1;
  overflow: auto;
}

.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}

.image-wrapper {
  background: black url('modal-info.png') no-repeat center center/100% 100%;
  position: relative;
}
.image-wrapper .back_icon {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
  zoom: 1.5;
}
.image-wrapper .cross_icon {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 10px;
  zoom: 1.5;
}

.main-img {
  height: 35vh;
  width: 100%;
  margin: 0 auto 0px;
}
.main-img.full-width {
  object-fit: cover;
}

.default-img {
  height: 35vh;
  width: 100px !important;
}

.info {
  padding: 20px;
}
.info .title {
  text-align: center;
  text-transform: uppercase;
  font-size: 25px;
  line-height: var(--modal-info-title-line-height);
  margin-bottom: 6px;
  padding-top: 10px;
  color: var(--ion-color-primary);
}
.info .desc {
  text-align: center;
  font-size: var(--modal-info-desc-font-size);
  font-family: AppFontNormal, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: #1a1a18;
}

.menge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 20px 20px;
}
.menge h5 {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  text-transform: uppercase;
}

ion-button {
  position: relative;
}
ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
  margin-right: 50px;
}
ion-button .buuton-text.one-button {
  margin-right: 0;
}
ion-button .button-price {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
}
ion-button .button-price.one-button {
  margin-right: 44px;
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}

ion-toolbar {
  height: 60px;
  display: flex;
  align-items: center;
  --background: var(--background-color);
}
ion-toolbar ion-title {
  font-weight: 100;
  padding-inline: unset !important;
  font-size: 16px;
  text-align: left;
  margin-left: 40px;
  font-family: AppFontBold, sans-serif;
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 15px;
}

.option-group-description {
  line-height: 95%;
  padding: 20px 25px;
  color: var(--ion-color-black);
  font-size: 20px;
  text-align: left;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  background: white;
}

swiper-container {
  height: 100% !important;
  width: 100%;
}

ion-page {
  background: transparent;
}

.slider-select-half {
  height: 100%;
  width: 100%;
}

.separator {
  height: 14px;
  width: 100%;
  background: url('separator_doted.svg') no-repeat center center/100% 100%;
}
@media (min-width: 991px) {
  .separator {
    background: url('separator_doted.svg') no-repeat center center/100% 130%;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .separator {
    height: 11px;
  }
}

.allergens {
  margin: 5px 20px;
}
.allergens app-accordion-list {
  width: 100%;
}

.padding-block {
  padding: 0px 20px;
}

.vertical-line {
  content: " ";
  width: 1px;
  height: 20px;
  color: white;
  background: white;
  margin-inline: 10px;
}

.add-background {
  background: black url('background.png') no-repeat center center/100% 100% !important;
  background-size: cover;
}

.button-footer-block {
  flex-wrap: wrap;
  background: white;
  justify-content: center;
  margin: 0px !important;
  padding: 0 15px 15px 15px;
  width: 100%;
  z-index: 999;
  box-shadow: 0px -4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  display: flex;
  font-size: 16px;
}
.button-footer-block ion-button {
  --padding-start: 24px;
  --padding-end: 7px;
  width: max-content;
  max-width: max-content;
  margin-left: 10px;
  margin-top: 15px;
  flex-grow: 1;
}
@media (max-width: 992px) {
  .button-footer-block ion-button {
    font-size: 14px;
  }
  .button-footer-block ion-button .button-price {
    font-size: 14px;
  }
}
.button-footer-block ion-button.one-button {
  width: 100%;
}
@media (max-width: 992px) {
  .button-footer-block ion-button:last-child {
    width: 35%;
  }
  .button-footer-block ion-button:last-child .buuton-text {
    font-size: 14px;
  }
}
.button-footer-block .buy_without_options {
  width: max-content;
  flex-grow: 12;
  --padding-start: 20px;
  --padding-end: 20px;
}

.style-block {
  height: 100%;
  overflow-y: auto;
  width: 100%;
}

.show-option-groups {
  background: white;
  display: flex;
  align-items: center;
}

.delete-option {
  position: absolute;
  bottom: 15px;
  right: 15px;
  z-index: 99;
  background: var(--ion-color-primary);
  border-top-left-radius: 15px;
  text-align: center;
  padding: 7px;
  border: 2px dotted white;
  width: 80px;
  height: 80px;
  min-height: 80px;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.delete-option p {
  font-size: 13px;
  font-family: "AppFontBold";
  text-transform: uppercase;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,kBAAA;AADD;;AAIA;EACC,sBAAA;EACA,uBAAA;EACA,yCAAA;AADD;;AAIA;EACC,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;EACA,WAAA;AADD;;AAMA;EACC,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAHD;;AAMA;EACC,YAAA;EACA,cAAA;AAHD;;AAMA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;AAHD;;AAKA;EACC,yEAAA;EACA,kBAAA;AAFD;AAGC;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;AADF;AAGC;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AADF;;AAIA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AADD;AAEC;EACC,iBAAA;AAAF;;AAGA;EACC,YAAA;EACA,uBAAA;AAAD;;AAEA;EACC,aAAA;AACD;AAAC;EACC,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;AAEF;AACC;EACC,kBAAA;EACA,2CAAA;EACA,sCAAA;EAEA,+CAAA;EACA,oBAAA;EACA,cAAA;AAAF;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EAMA,qBAAA;AAND;AACC;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAIA;EACC,kBAAA;AADD;AAGC;EACC,6CAAA;EACA,0CAAA;EACA,kBAAA;AADF;AAGE;EACC,eAAA;AADH;AAKC;EACC,6CAAA;EACA,0CAAA;AAHF;AAIE;EACC,kBAAA;AAFH;AAMC;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAJF;;AAQA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AALD;AAMC;EACC,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;AAJF;AAMC;EACC,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,+BAAA;AAJF;AAOC;EACC,YAAA;EACA,eAAA;AALF;;AAQA;EACC,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,iBAAA;AALD;;AAOA;EACC,uBAAA;EACA,WAAA;AAJD;;AAOA;EACC,uBAAA;AAJD;;AAMA;EACC,YAAA;EACA,WAAA;AAHD;;AAKA;EACC,YAAA;EACA,WAAA;EACA,wEAAA;AAFD;ACzLE;EDwLF;IAKE,wEAAA;EAAA;AACF;AAAE;EANF;IAOG,YAAA;EAGD;AACF;;AAAA;EACC,gBAAA;AAGD;AAFC;EACC,WAAA;AAIF;;AADA;EACC,iBAAA;AAID;;AAFA;EACC,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAKD;;AAHA;EACC,oFAAA;EACA,sBAAA;AAMD;;AAJA;EACC,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,aAAA;EACA,eAAA;AAOD;AANC;EACC,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAQF;AC5OE;ED6ND;IAUE,eAAA;EASD;EAPC;IACC,eAAA;EASF;AACF;AANE;EACC,WAAA;AAQH;ACvPE;EDkPA;IAEE,UAAA;EAOF;EANE;IACC,eAAA;EAQH;AACF;AAJC;EACC,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AAMF;;AAHA;EACC,YAAA;EACA,gBAAA;EACA,WAAA;AAMD;;AAJA;EACC,iBAAA;EACA,aAAA;EACA,mBAAA;AAOD;;AALA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,oCAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAOD;AANC;EACC,eAAA;EAEA,0BAAA;EACA,yBAAA;EACA,YAAA;AAOF","sourcesContent":["@import '../../../theme/mixins';\n\napp-modal-info {\n\theight: 100vh;\n\tposition: relative;\n}\n\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n\tbackground-color: var(--background-color);\n}\n\n.slide-col {\n\ttop: 0;\n\tbottom: 0;\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-size: 100% 30vh !important;\n\toverflow: auto;\n\twidth: 100%;\n\n\t// padding: 23px;\n}\n\n.option-group-col {\n\tflex-grow: 1;\n\toverflow: auto;\n\tflex-shrink: 1;\n\tflex-basis: auto;\n\tpadding: 15px 20px;\n}\n\n.grow {\n\tflex-grow: 1;\n\toverflow: auto;\n}\n\n.back-img {\n\tposition: absolute;\n\ttop: 30px;\n\tleft: 30px;\n}\n.image-wrapper {\n\tbackground: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n\tposition: relative;\n\t.back_icon {\n\t\tposition: absolute;\n\t\tleft: 10px;\n\t\ttop: 10px;\n\t\tz-index: 99;\n\t\tzoom: 1.5;\n\t}\n\t.cross_icon {\n\t\tz-index: 99;\n\t\tposition: absolute;\n\t\tright: 10px;\n\t\ttop: 10px;\n\t\tzoom: 1.5;\n\t}\n}\n.main-img {\n\theight: 35vh;\n\twidth: 100%;\n\tmargin: 0 auto 0px;\n\t&.full-width {\n\t\tobject-fit: cover;\n\t}\n}\n.default-img {\n\theight: 35vh;\n\twidth: 100px !important;\n}\n.info {\n\tpadding: 20px;\n\t.title {\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tfont-size: 25px;\n\t\tline-height: var(--modal-info-title-line-height);\n\t\tmargin-bottom: 6px;\n\t\tpadding-top: 10px;\n\t\tcolor: var(--ion-color-primary);\n\t}\n\n\t.desc {\n\t\ttext-align: center;\n\t\tfont-size: var(--modal-info-desc-font-size);\n\t\tfont-family: AppFontNormal, sans-serif;\n\n\t\tline-height: var(--modal-info-desc-line-height);\n\t\tpadding-bottom: 10px;\n\t\tcolor: #1a1a18;\n\t}\n}\n\n.menge {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\th5 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 18px;\n\t\ttext-transform: uppercase;\n\t}\n\tmargin: 0px 20px 20px;\n}\n\nion-button {\n\tposition: relative;\n\n\t.buuton-text {\n\t\tfont-size: var(--modal-info-button-font-size);\n\t\tcolor: var(--modal-info-button-text-color);\n\t\tmargin-right: 50px;\n\n\t\t&.one-button {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\n\t.button-price {\n\t\tfont-size: var(--modal-info-button-font-size);\n\t\tcolor: var(--modal-info-button-text-color);\n\t\t&.one-button {\n\t\t\tmargin-right: 44px;\n\t\t}\n\t}\n\n\t.button-icon {\n\t\tposition: absolute;\n\t\tright: 5px;\n\t\theight: 34px;\n\t\twidth: 34px;\n\t}\n}\n\nion-toolbar {\n\theight: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\t--background: var(--background-color);\n\tion-title {\n\t\tfont-weight: 100;\n\t\tpadding-inline: unset !important;\n\t\tfont-size: 16px;\n\t\ttext-align: left;\n\t\tmargin-left: 40px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t}\n\tion-button {\n\t\t--background: transparent;\n\t\t--background-activated: transparent;\n\t\t--background-focused: transparent;\n\t\t--background-hover: transparent;\n\t}\n\n\tion-icon {\n\t\tpadding: 8px;\n\t\tfont-size: 15px;\n\t}\n}\n.option-group-description {\n\tline-height: 95%;\n\tpadding: 20px 25px;\n\tcolor: var(--ion-color-black);\n\tfont-size: 20px;\n\ttext-align: left;\n\tfont-family: AppFontBold, sans-serif;\n\ttext-transform: uppercase;\n\tbackground: white;\n}\nswiper-container {\n\theight: 100% !important;\n\twidth: 100%;\n}\n\nion-page {\n\tbackground: transparent;\n}\n.slider-select-half {\n\theight: 100%;\n\twidth: 100%;\n}\n.separator {\n\theight: 14px;\n\twidth: 100%;\n\tbackground: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n\t@include desktop {\n\t\tbackground: url('../../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 130%;\n\t\t@media (max-height: 750px) {\n\t\t\theight: 11px;\n\t\t}\n\t}\n}\n.allergens {\n\tmargin: 5px 20px;\n\tapp-accordion-list {\n\t\twidth: 100%;\n\t}\n}\n.padding-block {\n\tpadding: 0px 20px;\n}\n.vertical-line {\n\tcontent: ' ';\n\twidth: 1px;\n\theight: 20px;\n\tcolor: white;\n\tbackground: white;\n\tmargin-inline: 10px;\n}\n.add-background {\n\tbackground: black url(../../../assets/background/background.png) no-repeat center center / 100% 100% !important;\n\tbackground-size: cover;\n}\n.button-footer-block {\n\tflex-wrap: wrap;\n\tbackground: white;\n\tjustify-content: center;\n\tmargin: 0px !important;\n\tpadding: 0 15px 15px 15px;\n\twidth: 100%;\n\tz-index: 999;\n\tbox-shadow: 0px -4px 50px 0px #0000001a;\n\tdisplay: flex;\n\tfont-size: 16px;\n\tion-button {\n\t\t--padding-start: 24px;\n\t\t--padding-end: 7px;\n\t\twidth: max-content;\n\t\tmax-width: max-content;\n\t\tmargin-left: 10px;\n\t\tmargin-top: 15px;\n\t\tflex-grow: 1;\n\n\t\t@include mobile {\n\t\t\tfont-size: 14px;\n\n\t\t\t.button-price {\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t}\n\n\t\t&.one-button {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t&:last-child {\n\t\t\t@include mobile {\n\t\t\t\twidth: 35%;\n\t\t\t\t.buuton-text {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.buy_without_options {\n\t\twidth: max-content;\n\t\tflex-grow: 12;\n\t\t--padding-start: 20px;\n\t\t--padding-end: 20px;\n\t}\n}\n.style-block {\n\theight: 100%;\n\toverflow-y: auto;\n\twidth: 100%;\n}\n.show-option-groups {\n\tbackground: white;\n\tdisplay: flex;\n\talign-items: center;\n}\n.delete-option {\n\tposition: absolute;\n\tbottom: 15px;\n\tright: 15px;\n\n\tz-index: 99;\n\tbackground: var(--ion-color-primary);\n\tborder-top-left-radius: 15px;\n\ttext-align: center;\n\tpadding: 7px;\n\tborder: 2px dotted white;\n\twidth: 80px;\n\theight: 80px;\n\tmin-height: 80px;\n\tmin-width: 80px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\tp {\n\t\tfont-size: 13px;\n\n\t\tfont-family: 'AppFontBold';\n\t\ttext-transform: uppercase;\n\t\tcolor: white;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
